export const ROUTES = {
    LANDING: '/',
    HOME: '/home',
    VIEW_SHIPP_With_Id: (shippid: string) => `/shipp/${shippid}`,
    VIEW_SHIPP: '/shipp',
    SIGN_IN: '/signin',
    SIGN_UP: '/signup',
    NEW_SHIPP: '/newshipp',
    LIST_SHIPP: (state: string) => `/shipps/${state}`,
    EDIT_SHIPP: `/editshipp`,
    UPDATE_SHIPP: (shippid: string) => `/updateshipp/${shippid}`,
    ADMIN_CONTROL: `/admincontrol`,
    CAPTINS_LIST: '/listcaptins',
    ADD_CAPTIN: '/addcaptin',
    CONTROL_USER: '/controluser',
    USER_PROFILE: '/userprofile',
    FORGOT_PASSWORD: '/forgotpass',
    RESET_PASSWORD : (token: string) => `/resetpass/${token}`,
  };